export enum OperationContext {
  Earthmoving = 'earthmovingContext',
  Stabilization = 'stabilizationContext'
}